import * as React from 'react';

import styles from './tooltips.module.css';

type PrefixProps = {
    currencyPrefix?: string;
};
export function Prefix({currencyPrefix}: PrefixProps) {
    return <td className={styles['unit-label']}>{currencyPrefix}</td>;
}
